import User from '../../../base/errors/user';
import create from './Create';

const user: User = {
  create,
  notificationChannelUnableToLoad: 'Nepodařilo se načíst stupeň přijímání notifikací haly'
};

export default user;
